// PhonicsLt05.js
// 包装组件：Letter Teams L05
// 路由：/phonics/lt05
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt05 } from './phonics/phonics_data_lt05';

function PhonicsLt05() {
  return <PhonicsLt letterData={letterDataLt05} />;
}

export default PhonicsLt05;
